import React from 'react';

const StatusIndicator = ({ 
  type = 'inactive', 
  size = 'default', 
  animated = true,
  className = '',
  label = null 
}) => {
  const sizeClasses = {
    xs: 'w-1.5 h-1.5',
    sm: 'w-2 h-2',
    default: 'w-3 h-3',
    lg: 'w-4 h-4'
  };

  const typeClasses = {
    active: 'bg-success',
    inactive: 'bg-muted-foreground',
    warning: 'bg-warning',
    error: 'bg-error',
    connecting: 'bg-accent'
  };

  const pulseAnimation = animated && (type === 'active' || type === 'connecting');

  return (
    <div className={`flex items-center space-x-1 ${className}`}>
      <div
        className={`
          rounded-full flex-shrink-0
          ${sizeClasses?.[size]}
          ${typeClasses?.[type]}
          ${pulseAnimation ? 'status-pulse' : ''}
        `}
        aria-label={label || `Status: ${type}`}
        role="status"
      />
      {label && (
        <span className="text-xs text-muted-foreground font-medium">
          {label}
        </span>
      )}
    </div>
  );
};

export default StatusIndicator;